import {useEffect, useState} from "react";
import Remark from "remark-parse";
import {unified} from "unified";
import styles from "./index.module.scss";
const Summary = ({ project }) => {

    const [headings, setHeadings] = useState([]);
    const [progress, setProgress] = useState(0);
    async function getSummary() {
        const processor = unified().use(Remark);
        const markdownAST = processor.parse(project.content);
        const headings = markdownAST.children.filter(
            (node) => node.type === "heading"
        );

        headings.forEach((h,i)=>{
            const targets = document.querySelectorAll('h'+h.depth);
            h.target = Array.from(targets).find((target)=>{
                return target.innerText === h.children[0].value;
            });
            h.target.dataset.headingIndex = i;
        })

        headings.push({depth: 2, children: [{value: "Annexes"}], target: document.querySelector("[data-annexes]")})
        setHeadings(headings);

    }

    useEffect(() => {
        function callback() {
            let i = 0
            let hasOneActive = false;
            let activeIndex = 0;
            for(let heading of headings){
                const rect = heading.target.getBoundingClientRect();
                heading.target.dataset.active = rect.top >= 0 && rect.top <= 900;
                if(heading.target.dataset.active == "true" && hasOneActive == false) {
                    let el = document.querySelector(`[data-heading-index="${i}"]`);
                    if(!el) return;
                    el.dataset.active = "true";
                    hasOneActive = true;
                    activeIndex = i;
                }else{
                    let el = document.querySelector(`[data-heading-index="${i}"]`);
                    if(!el) return;
                    el.dataset.active = "false";
                }
                i++;

            }

            let progression = activeIndex / (headings.length - 1) * 100;
            setProgress(progression)
        }

        window.addEventListener("scroll", callback)
        return () => {
            window.removeEventListener("scroll", callback)
        }
    }, [headings]);

    useEffect(() => {
        getSummary();
    }, [project]);


    const summary = headings.map((h,i)=> {
        const text = h.children[0].value

        h.el = <a key={"sum-"+i} href={'?heading-index='+i} onClick={(e) => {
            e.preventDefault();
            h.target.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }}>
            <li data-depth={h.depth} data-heading-index={i}>{text}</li>
        </a>
        return h.el
    })

    return (
        <>
            <div className={styles.progressArticle}>
                <div style={
                    {
                        width: progress + "%"
                    }
                } ></div>
            </div>
            <aside className={styles.summary}>
                <nav>
                    <ul>
                        {summary}
                    </ul>
                </nav>
            </aside>
        </>
    );
}

export default Summary;

